export function getForeignAmountFromCurrencyPair(
  currencyFromCode: string | null | undefined,
  currencyToCode: string | null | undefined,
  fromAmount: number,
  toAmount: number,
): number {
  const fromCode = (currencyFromCode ?? '').trim().toUpperCase();
  const toCode = (currencyToCode ?? '').trim().toUpperCase();
  const fromAmt = Number(fromAmount) || 0;
  const toAmt = Number(toAmount) || 0;

  if (fromCode && fromCode !== 'MXN') {
    return fromAmt;
  }
  if (toCode && toCode !== 'MXN') {
    return toAmt;
  }
  return fromAmt || toAmt;
}
